<script setup>
  /**
   * Responsibilities:
   * - Ensure required authentication state.
   * - Middleware ensures application config has been properly routed, hydrated, and transitions set
   * - Retrieve and pass proper prop values to appModule
   */
  import AppModule from '~/components/app-config/app-modules/AppModule.vue'
  import { useApplicationConfigStore } from '~/store/application-config'

  definePageMeta({
    middleware: [
      'app-config-page',
    ],
    pageTransition: {
      mode: 'out-in'
    }
  })

  const applicationConfigStore = useApplicationConfigStore()
  const { getModuleFromSlug } = applicationConfigStore
  const { applicationConfig, submitSections } = storeToRefs(applicationConfigStore)
  const { slug } = getAppConfigRouteData()
  const applicationModule = getModuleFromSlug(slug)
  if (!applicationModule || !applicationModule.includesData) {
    throw createError({
      statusCode: 404,
      statusMessage: `Application Module not loaded. Url: ${slug}`,
      fatal: true
    })
  }
</script>

<template>
  <div>
    <AppModule
      v-if="applicationModule"
      :showConfigSkip="applicationConfig?.showSkip"
      :applicationModule="applicationModule"
      :submitSections="applicationModule?.moduleSections || applicationConfig?.submitSections || submitSections"
      :moduleUrlPrefix="applicationConfig?.moduleUrlPrefix"
      :configPrevious="applicationConfig?.urlPrevious"
      :configNext="applicationConfig?.urlNext"
      :configSkip="applicationConfig?.urlSkip"
    />
  </div>
</template>
